import {MessageCodes} from "../MessageCodes";
import {useAppContext} from "../../../context/AppContext";
import ResultView from "../../../components/ResultView";
import ResultText from "../ResultText";
import EmptyLine from "../EmptyLine";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultBody from "../../../components/table/ResultBody";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultCellHighlight from "../../../components/table/ResultCellHighlight";
import HecRasHelper from "../../../helpers/HecRasHelper";

function fmtNumber(value, digits = 2) {
    if (value === null || value === undefined || Number.isNaN(value)) return '-'
    const n = Number(value)
    if (!Number.isFinite(n)) return '-'
    return n.toLocaleString(undefined, {minimumFractionDigits: digits, maximumFractionDigits: digits})
}

export function COV3({message_key}) {
    const {getSelectedHistory} = useAppContext()
    const summary = getSelectedHistory()?.summary
    const bi = summary?.base?.crossSectionSpacingIndices
    const ci = summary?.compare?.crossSectionSpacingIndices

    if (!bi && !ci) return null

    const rows = [
        {label: 'Median Top Width (ft)', field: 'median_top_width', digits: 0},
        {label: 'Median Reach Length (ft)', field: 'median_reach_length', digits: 0},
        {label: 'Reach Slope (%)', field: 'reach_slope_pct', digits: 1},
        {label: 'Top Width Ratio Index', field: 'top_width_ratio_index', digits: 1},
        {label: "Samuel's Equation Index", field: 'samuel_equation_index', digits: 1},
    ]

    return (
        <ResultView error_id={MessageCodes.Compare.COV03.error_id} message_key={message_key}>
            <ResultText>
                The geometry statistics of the base and comparison plans are calculated as follows. The differences are highlighted in red.
            </ResultText>
            <EmptyLine/>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{width: HecRasHelper.getWidth(40)}}/>
                        <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>Base Plan</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>Comparison Plan</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {rows.map((r, idx) => {
                        const baseVal = fmtNumber(bi?.[r.field], r.digits)
                        const cmpVal = fmtNumber(ci?.[r.field], r.digits)
                        return (
                            <ResultRow key={idx}>
                                <ResultHeaderCell style={{textAlign: 'left'}}>{r.label}</ResultHeaderCell>
                                <ResultBodyCell style={{textAlign: 'right'}}>{baseVal}</ResultBodyCell>
                                <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(baseVal, cmpVal)}</ResultBodyCell>
                            </ResultRow>
                        )
                    })}
                </ResultBody>
            </ResultTable>
        </ResultView>
    )
}
